import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Result, Button } from 'antd';
import { PropertyPricingForm } from './forms';
import PropertySettingsTable from './PropertySettingsTable';

import PropertyActions, { PropertySelectors } from '@redux/PropertyRedux';

function PricingDetails(props) {
  const { setCurrentPropertySetting, activeGlobalSetting } = props;

  const { data: activePricing } = activeGlobalSetting || {};
  const [showForm, setShowForm] = useState(false);

  const handleCreateNew = () => {
    setCurrentPropertySetting(activePricing);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  if (!activePricing) {
    return (
      <Result
        status="warning"
        title="Sorry, please activate global property setting first"
      />
    );
  }

  if (showForm) {
    return <PropertyPricingForm closeForm={handleCloseForm} />;
  }

  return (
    <div>
      <Button key="1" type="primary" onClick={handleCreateNew}>
        CREATE NEW PROPERTY SETTINGS
      </Button>
      <PropertySettingsTable />
    </div>
  );
}

PricingDetails.propTypes = {
  activeGlobalSetting: PropTypes.object,
  setCurrentPropertySetting: PropTypes.func
};

const mapStateToProps = state => ({
  activeGlobalSetting: PropertySelectors.selectActiveGlobalSetting(state)
});

const mapDispatchToProps = dispatch => ({
  setCurrentPropertySetting: data =>
    dispatch(PropertyActions.setCurrentPropertySetting(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PricingDetails);
